var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 320C179.817 320 144 284.183 144 240S179.817 160 224 160S304 195.817 304 240S268.183 320 224 320ZM512 0H64C28.654 0 0 28.652 0 64V416C0 451.346 28.654 480 64 480H80L96 512H160L176 480H400L416 512H480L496 480H512C547.346 480 576 451.346 576 416V64C576 28.652 547.346 0 512 0ZM224 400C135.635 400 64 328.365 64 240S135.635 80 224 80S384 151.635 384 240S312.365 400 224 400ZM480 221.062V336C480 344.844 472.844 352 464 352S448 344.844 448 336V221.062C429.4 214.451 416 196.869 416 176C416 149.49 437.49 128 464 128S512 149.49 512 176C512 196.869 498.6 214.451 480 221.062Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.0d033cc86c76599bde5233a373fb0fff.svg";
export { ForwardRef as ReactComponent };